import { isEmpty } from 'lodash';

export const removeURLProtocols = (url: string) =>
  isEmpty(url)
    ? url
    : url
        .toLowerCase()
        .replace(/^(?:https?:\/\/)?(?:www\.)?/gi, '')
        .split('/')[0];
